import { useContext } from 'react';
import Checkbox from '@/srp/FiltersMenu/Checkbox';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import Label from '../Label';

type OwnProps = {
  make: string;
  model: string;
};

export default function ParentModel({ make, model }: OwnProps) {
  const { appliedFilters, updateMakes } = useContext(AppliedFiltersContext);

  const appliedMakes = appliedFilters?.makes?.find(
    appliedMake => appliedMake.name === make
  );

  const isSelected = appliedMakes?.parentModels?.some(
    appliedModel => appliedModel.name === model
  );

  return (
    <Checkbox
      facet="parent-models"
      filter={model}
      id={`parent-model-${model}`}
      checked={isSelected}
      onChange={() =>
        updateMakes({
          modelsKey: 'parentModels',
          name: model,
          parents: [make]
        })
      }
      label={<Label displayName={model} />}
    />
  );
}
